import Image from "next/image";
import Layout from "@/components/layout";
import styles from "@/styles/ServicesDetail.module.css";
import { useRouter } from "next/router";
import { Container, Row, Col, Accordion, Button } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import Link from "next/link";

const HealingTouch = () => {
  const router = useRouter();
  const [next, setNext] = useState(false);
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <section
        className={`${styles["section-banner"]} "banner-page"`}
        style={{ background: "url(/images/healing-touch-banner.png)" }}
        ref={firstSectionRef}
      >
        <Container>
          <Row>
            <Col lg={10} className="m-auto">
              <div className={styles["inner-content"]}>
                <h1 className={styles["banner-title"]}>
                  Welcome to Our Healing Touch Service!
                </h1>
                <p>
                  At Zenkify, we Believe in Healing. Welcome to Our Healing
                  Touch Service at Our Wellness Oasis. Discover the
                  transformative power of gentle energy work promoting
                  relaxation, pain relief, and holistic well-being. Rejuvenate
                  your body, mind, and spirit with us.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className={styles["content-grid"] + " " + styles["section-content"]}
      >
        <Container>
          <Row>
            <Col
              lg={7}
              className="me-auto align-self-center order-lg-1 order-2"
            >
              <div className={styles["inner-content"]}>
                <h2>About Healing Touch</h2>
                <p>
                  Healing Touch is an energy-based healing modality that
                  involves using the hands to promote physical, emotional,
                  mental, and spiritual well-being. Healing Touch is based on
                  the principle that the human body has an energy system that
                  can be influenced for healing purposes. Practitioners use
                  their hands to assess and manipulate the energy field
                  surrounding the body, working with the energy centres
                  (chakras) and energy pathways (meridians) to restore balance
                  and promote the body&apos;s natural healing abilities.
                </p>
              </div>
            </Col>
            <Col lg={4} className="order-lg-2 order-1">
              <div className={styles["image"]}>
                <Image
                  width={400}
                  height={364}
                  src="/images/healing-touch-service.svg"
                  alt="About Healing Touch"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className={`${styles["content-grid"]} ${styles["working-section"]}`}
      >
        <Image
          width={150}
          height={101}
          src="/images/flower-shap-3.svg"
          className={styles["flower-top"]}
          alt="flower-shap"
        />
        <Image
          width={100}
          height={101}
          src="/images/flower-2.svg"
          className={styles["flower-right"]}
          alt="flower-shap"
        />
        <Container>
          <Row>
            <Col lg={4}>
              <Image
                width={420}
                height={418}
                src="/images/healing-touch.png"
                className={styles["reikiwork-image"]}
                alt="Reiki Healing Service"
              />
            </Col>
            <Col lg={8} className="ms-auto align-self-center ps-md-5">
              <div className={styles["inner-content"] + " " + "pe-0"}>
                <h3>How Does Healing Touch Work</h3>
                <p>
                  Healing Touch involves the practitioner&apos;s hands
                  interacting with the recipient&apos;s energy field to restore
                  balance and promote healing. Through gentle touch and energy
                  manipulation, it aims to alleviate stress, reduce pain, and
                  enhance the body&apos;s innate healing processes. While the
                  scientific basis is still being explored, this approach is
                  grounded in the idea of energy flow and its impact on
                  well-being, offering relaxation and potential relief from
                  various ailments.{" "}
                </p>
                <ul>
                  <li>Energy Field Interaction</li>
                  <li>Stress and Pain Alleviation</li>
                  <li>Balance Restoration</li>
                  <li>Support for Healing Processes</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          width={79}
          height={130}
          src="/images/flower-shap-2.svg"
          className={styles["flower-bottom"]}
          alt="flower-shap"
        />
      </section>
      <section
        className={
          styles["benefits-service"] + " " + styles["benefits-healing"]
        }
      >
        <Container>
          <Row>
            <Col lg={8} className="m-auto pb-4">
              <div className="section-title">
                <h3 className="title">Benefits of Healing Touch</h3>
                <p>
                  Healing Touch provides comprehensive advantages, including
                  alleviating pain, reducing stress, and promoting emotional
                  equilibrium. By harmonizing the body&apos;s energy field, it
                  facilitates innate healing mechanisms, bolsters immune
                  function, and nurtures overall health. This gentle modality
                  supplements conventional medical treatments, fostering
                  physical, emotional, and spiritual well-being.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Pain Reduction</h4>
                <p>
                  Healing Touch, an energy-based therapy, can alleviate pain and
                  discomfort by restoring energy balance within the body&apos;s
                  energy field.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Stress Relief</h4>
                <p>
                  By promoting relaxation, Healing Touch helps reduce stress and
                  anxiety, fostering a sense of well-being.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Accelerated Healing</h4>
                <p>
                  This technique supports the body&apos;s natural healing
                  processes, potentially leading to quicker recovery from
                  injuries or illnesses.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Emotional Balance</h4>
                <p>
                  Healing Touch can harmonize emotional imbalances, aiding in
                  emotional healing and stability.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Enhanced Immunity</h4>
                <p>
                  Through energy flow optimization, Healing Touch may contribute
                  to a strengthened immune system.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Holistic Wellness</h4>
                <p>
                  By addressing physical, emotional, and energetic aspects,
                  Healing Touch supports overall holistic wellness, promoting a
                  sense of wholeness and vitality.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          width={100}
          height={128}
          src="/images/stone-icon.svg"
          className={styles["stone-image"]}
          alt="flower"
        />
      </section>
      <section className={styles["service-section"]}>
        <Container>
          <Row>
            <Col md={4} className="mb-md-0 mb-2">
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/healing-touch-1.png"
                  alt="renki healing"
                />
              </div>
            </Col>
            <Col md={4} className="mb-md-0 mb-2">
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/healing-touch-2.png"
                  alt="renki healing"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/healing-touch-3.png"
                  alt="renki healing"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="faq-section">
        <Container>
          <Row>
            <Col lg={10} className="m-auto">
              <div className="section-title">
                <h3 className="title">FAQ’s</h3>
                <p>
                  Get Answers to your Questions.Learn and Discover Energy
                  Healing Benefits, Sessions, Techniques, and more. Clear your
                  Doubts and make an Informed Choice. Explore Energy Healing
                  with our FAQs.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="m-auto">
              <Accordion
                defaultActiveKey="0"
                className="faq-accordion"
                id="accordionExample"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>
                      What is Zenkify&apos;s approach to Healing Touch therapy?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      {" "}
                      Zenkify uses energy healing and the transforming potential
                      of little gestures to improve general well-being. For
                      complete support of physical, mental, and spiritual
                      health, their services combine several techniques,
                      including Reiki, Theta, and Healing Touch Services in the
                      USA.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <span>
                      How does Zenkify incorporate Healing Touch into its
                      services?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify incorporates Healing Touch Therapy Services in the
                      USA by offering a range of energy healing treatments,
                      including Reiki and Theta healing. These treatments help
                      people feel more relaxed, less stressed, and healthier.
                      Combining various methods, Zenkify seeks to offer a
                      comprehensive healing method that recognises the
                      interdependence of mental, emotional, and spiritual
                      well-being.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <span>
                      Can Healing Touch therapy provided by Zenkify complement
                      traditional medical treatments?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Although opinions among scientists on the efficacy of
                      non-contact therapies such as Healing Touch Services in
                      the USA are still split, Zenkify&apos;s services are meant
                      to enhance rather than replace traditional medical
                      treatment. Zenkify seeks to assist patients in their whole
                      health journey by providing a comprehensive approach to
                      healing, improving the advantages of medical treatments,
                      and encouraging a more balanced attitude to well-being.{" "}
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <span>
                      Are Zenkify&apos;s Healing Touch services suitable for all
                      ages?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Since Zenkify&apos;s Healing Touch services in the USA
                      address each client&apos;s particular needs and problems,
                      they are appropriate for people of all ages.
                      Zenkify&apos;s treatments are made to be flexible and
                      approachable to a broad spectrum of clients, whether they
                      are looking for relaxation, stress reduction, or general
                      wellness.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <span>
                      What are the benefits of choosing Zenkify for Healing
                      Touch therapy?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Selecting Zenkify for Healing touch services in the USA
                      has many benefits. Their skilled therapists provide a
                      customized approach to healing by combining several
                      modalities to customize therapies to specific needs.
                      Zenkify is also a desirable choice for people looking for
                      comprehensive help because their services are made to
                      encourage relaxation, lower stress, and improve general
                      well-being.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <span>
                      How does Zenkify ensure the effectiveness of its Healing
                      Touch services?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify guarantees the efficacy of its Healing Touch
                      services in the USA by using skilled and licensed
                      therapists who are knowledgeable in various energy healing
                      treatments. Their therapists collaborate directly with
                      customers to identify their individual needs and customize
                      treatments to maximize every session for effectiveness.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <span>
                      Are Zenkify&apos;s Healing Touch therapists certified and
                      experienced?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify Healing Touch therapists hold certifications and
                      have years of expertise. Because of their experience, they
                      can provide excellent healing touch therapies in the USA
                      that meet the various requirements of their patients.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                    <span>
                      What makes Zenkify&apos;s Healing Touch therapy different
                      from other providers?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify&apos;s Healing Touch therapy differs from other
                      providers in several key ways:
                    </p>
                    <p>
                      <strong>Personalized Approach:</strong> Zenkify tailors
                      each session to the individual client&apos;s needs, taking
                      into account their unique physical, emotional, and
                      spiritual well-being. This personalized approach ensures
                      that the therapy is effective and aligned with the
                      client&apos;s goals.
                    </p>
                    <p>
                      <strong>Holistic Healing:</strong> Zenkify&apos;s Healing
                      Touch therapy combines various modalities, including
                      reiki, chakra balancing, and crystal healing, to provide a
                      comprehensive and holistic healing experience. This
                      approach addresses the mind, body, and spirit, promoting
                      overall well-being.
                    </p>
                    <p>
                      <strong>Certified Practitioners:</strong> All of
                      Zenkify&apos;s practitioners are certified in Healing
                      Touch and have undergone extensive training to ensure they
                      provide high-quality, safe, and effective therapy. This
                      commitment to professionalism sets Zenkify apart from some
                      other providers.
                    </p>
                    <p>
                      <strong>Relaxing Environment:</strong> Zenkify&apos;s
                      studio is designed to create a calming and serene
                      atmosphere, with soft lighting, soothing music, and
                      comfortable treatment tables. This environment helps
                      clients relax and fully immerse themselves in the healing
                      process.
                    </p>
                    <p>
                      <strong>Ongoing Support:</strong> Zenkify offers ongoing
                      support to clients through follow-up sessions, email
                      check-ins, and a supportive community. This commitment to
                      long-term healing and well-being sets Zenkify apart from
                      providers who offer one-time sessions.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                  <Accordion.Header>
                    <span>
                      Can Zenkify&apos;s Healing Touch therapy help with
                      specific health conditions?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Although Healing Touch therapy in the USA cannot replace
                      medical care, it can help control several health issues.
                      Zenkify offers services that are meant to aid those who
                      are suffering from chronic pain, anxiety, or depression,
                      in particular by promoting relaxation, lowering stress,
                      and improving general well-being.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="9">
                  <Accordion.Header>
                    <span>
                      What should I expect during a Healing Touch session with
                      Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      During a Healing Touch session with Zenkify, you can
                      expect a personalized approach combining reiki, chakra
                      balancing, and crystal healing in a relaxing environment.
                      The certified practitioner will use gentle, non-invasive
                      touch to clear energy imbalances and promote relaxation.
                      You may experience sensations, images, and emotional
                      release as your body&apos;s self-healing mechanisms are
                      supported.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                {next == false ? (
                  <div className="text-center ">
                    <Button
                      className="theme-btn text-align-center my-4"
                      onClick={() => setNext(true)}
                    >
                      View more
                    </Button>
                  </div>
                ) : (
                  <>
                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        <span>
                          How frequently should I schedule Healing Touch
                          sessions with Zenkify for optimal results?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Regular Healing Touch Services in the USA with Zenkify
                          are advised for the best outcomes. Regular sessions
                          can assist in preserving a sense of relaxation and
                          well-being; the frequency of sessions varies depending
                          on personal needs and objectives.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="11">
                      <Accordion.Header>
                        <span>
                          Does Zenkify offer any packages or discounts for its
                          Healing Touch services?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          To make its Healing Touch services in the USA more
                          accessible to a more extensive clientele, Zenkify
                          offers a variety of packages and discounts. The
                          flexibility and value these packages provide clients
                          can be customized to meet their specific requirements
                          and objectives.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="12">
                      <Accordion.Header>
                        <span>
                          Can Zenkify provide remote Healing Touch sessions?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Healing Touch sessions can be accessed remotely by
                          clients of Zenkify from the comfort of their homes.
                          Those with busy schedules or mobility problems will
                          significantly benefit from this flexibility.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="13">
                      <Accordion.Header>
                        <span>
                          Are there any side effects or risks associated with
                          Zenkify&apos;s Healing Touch therapy?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          <strong>Healing Touch therapy in the USA</strong> from
                          Zenkify is usually regarded as safe and devoid of
                          significant side effects or hazards. To be sure the
                          treatment is appropriate for your circumstances, as
                          with any energy healing technique, you should speak
                          with a licensed therapist.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="14">
                      <Accordion.Header>
                        <span>
                          How long has Zenkify been offering Healing Touch
                          services?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Zenkify has been delivering Healing Touch services in
                          the USA for some time, emphasizing supplying
                          individualized, high-quality treatments that meet the
                          various demands of its clients.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="15">
                      <Accordion.Header>
                        <span>
                          Does Zenkify customize Healing Touch treatments based
                          on individual needs?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Zenkify ensures that every Healing Touch session is
                          catered to the customer&apos;s needs by customizing it
                          according to their demands. Clients can reap all the
                          advantages of energy healing thanks to this customized
                          method.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="16">
                      <Accordion.Header>
                        <span>
                          What sets Zenkify apart in the field of Healing Touch
                          therapy?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Zenkify is unique among Healing Touch therapies in the
                          USA because of its all-encompassing methodology, which
                          combines several modalities to handle the intricate
                          interactions between physical, emotional, and
                          spiritual well-being. Differentiating them from other
                          providers are their skilled therapists and customized
                          treatments.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="17">
                      <Accordion.Header>
                        <span>
                          Does insurance cover Zenkify&apos;s Healing Touch
                          services?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Since Zenkify&apos;s Healing Touch services in the USA
                          are regarded as alternative therapies, insurance
                          usually does not cover them. All the same, these
                          services can have a significant impact, and many
                          customers consider them to be a wise investment in
                          their general health.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="18">
                      <Accordion.Header>
                        <span>
                          Can I combine Healing Touch therapy with other
                          services offered by Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Theta and Reiki healing are two other services that
                          Zenkify provides. Clients can thus benefit from a
                          comprehensive healing strategy that attends to their
                          spiritual, emotional, and bodily needs.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="19">
                      <Accordion.Header>
                        <span>
                          How can I schedule a consultation or appointment for
                          Healing Touch therapy with Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Zenkify offers clients the option to make an
                          appointment or consultation for Healing Touch therapy
                          by visiting their website. Experienced therapists at
                          Zenkify will collaborate directly with clients to
                          determine their needs and customize therapies to
                          guarantee a customized approach to recovery.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </>
                )}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
      <Link
        id="floatingBook"
        className="floating-book"
        aria-label="Book a FREE call now"
        href="/healers"
        style={{ opacity: showSideButton ? 1 : 0 }}
      >
        Book a FREE call now
      </Link>
    </>
  );
};

export default HealingTouch;

HealingTouch.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};
